(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ag-product-ux"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__agProductUxInstalled) return;
  window.__agProductUxInstalled = true;
  const instances = new Map();
  // textContent also works while native details are closed.
  const hasContent = (element) => {
    if (!element) return false;
    const copy = element.cloneNode(true);
    copy.querySelectorAll('script,style,template,noscript,[hidden],[aria-hidden="true"],.visually-hidden,.sr-only').forEach(node => node.remove());
    const text = (copy.textContent || '').replace(/[\s\u00a0\u200b-\u200d\ufeff]/g, '');
    return text.length > 0 || Boolean(copy.querySelector('img[src],img[data-src],video,audio,iframe[src],model-viewer,canvas'));
  };
  const refresh = root => {
    root.querySelectorAll('.product__accordion').forEach(row => {
      const panel = row.querySelector('.accordion__content');
      if (!panel) return;
      const empty = !hasContent(panel);
      if (empty && !row.hasAttribute('data-ag-empty-accordion')) {
        row.setAttribute('data-ag-empty-accordion', 'true');
        if (!row.hidden) { row.setAttribute('data-ag-ux-hidden', 'true'); row.hidden = true; }
      } else if (!empty && row.hasAttribute('data-ag-empty-accordion')) {
        row.removeAttribute('data-ag-empty-accordion');
        if (row.hasAttribute('data-ag-ux-hidden')) { row.removeAttribute('data-ag-ux-hidden'); row.hidden = false; }
      }
    });
    root.querySelectorAll('select.select__select').forEach(select => {
      const selected = select.options[select.selectedIndex];
      if (selected) select.title = selected.textContent.trim();
    });
  };
  const attach = root => {
    if (instances.has(root)) return;
    refresh(root);
    let pending = 0;
    const schedule = () => {
      if (pending) return;
      pending = window.setTimeout(() => { pending = 0; if (root.isConnected) refresh(root); }, 60);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['class','style','hidden','aria-hidden','src'] });
    root.addEventListener('change', schedule);
    instances.set(root, () => { observer.disconnect(); window.clearTimeout(pending); root.removeEventListener('change', schedule); });
  };
  const boot = () => {
    instances.forEach((dispose, root) => { if (!root.isConnected) { dispose(); instances.delete(root); } });
    document.querySelectorAll('.product-section .product__info-container').forEach(attach);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, root) => { if (event.target.contains(root)) { dispose(); instances.delete(root); } });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
